module.exports = __webpack_public_path__ + "img/logo.2b91ff0e.svg";